import React, {useState} from "react";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";

export default function ContactSearcher({type, searchData, setSearchData, onSelect, selected, disabled, name}){
    const [isLoading, setLoading] = useState(false);
    const [, setTypeahead] = useState();

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=${type}&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };


    return (
          <AsyncTypeahead
              useCache={false}
              id="typeahead"
              labelKey="display_name"
              minLength={2}
              name={name}
              onSearch={handleSearch}
              onChange={onSelect}
              placeholder={`Search ${name}`}
              options={searchData}
              ref={typeahead => setTypeahead(typeahead)}
              className="typeahead"
              isLoading={isLoading}
              selected={selected ? [selected] : []}
              disabled={disabled}
          />
    )


}